import { formatUserFacingError } from '@/lib/errors'
import { useEffect, useState } from 'react'
import { seasonsService } from '../services/seasons.service'
import type { SeasonDocument } from '@/types'

interface UseSeasonsResult {
  seasons: Array<SeasonDocument & { id: string }>
  loading: boolean
  error: string | null
}

export function useSeasons(): UseSeasonsResult {
  const [seasons, setSeasons] = useState<Array<SeasonDocument & { id: string }>>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    seasonsService
      .getPublishedSeasons()
      .then(setSeasons)
      .catch((err: unknown) => setError(formatUserFacingError(err, 'Failed to load seasons')))
      .finally(() => setLoading(false))
  }, [])

  return { seasons, loading, error }
}
